import { lazy } from 'react';

const Projects = lazy(() => import('../pages/Projects.jsx'));
const HomeDashboard = lazy(() => import('../pages/HomeDashboard.jsx'));
const ProjectDetails = lazy(() => import('../pages/ProjectDetails.jsx'));
const Departments = lazy(() => import('../pages/Departments.jsx'));
const DepartmentDashboard = lazy(() => import('../pages/DepartmentDashboard.jsx'));
const TasksDashboard = lazy(() => import('../pages/TasksDashboard.jsx'));
const TicketsDashboard = lazy(() => import('../pages/TicketsDashboard.jsx'));
const TodoScratchpad = lazy(() => import('../pages/TodoScratchpad.jsx'));
const CalendarDashboard = lazy(() => import('../pages/CalendarDashboard.jsx'));
const Login = lazy(() => import('../pages/Login.jsx'));
const Register = lazy(() => import('../pages/Register.jsx'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword.jsx'));
const ResetPassword = lazy(() => import('../pages/ResetPassword.jsx'));
const Profile = lazy(() => import('../pages/Profile.jsx'));
const Users = lazy(() => import('../pages/Users.jsx'));
const FeaturePlannerWizard = lazy(() => import('../pages/FeaturePlannerWizard.jsx'));
const FeatureDetail = lazy(() => import('../pages/FeatureDetail.jsx'));

export const publicRoutes = [
  { path: '/login', element: <Login /> },
  // { path: '/register', element: <Register /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password/:token', element: <ResetPassword /> },
];

export const protectedRoutes = [
  { path: 'dashboard', element: <HomeDashboard /> },
  { path: '/calendar', element: <CalendarDashboard /> },
  { path: 'tasks', element: <TasksDashboard /> },
  { path: 'tickets', element: <TicketsDashboard /> },
  { path: 'tickets/:id', element: <TicketsDashboard /> },
  { path: 'todos', element: <TodoScratchpad /> },
  { path: 'projects', element: <Projects /> },
  { path: 'projects/:id', element: <ProjectDetails /> },
  { path: 'projects/:projectId/features/new', element: <FeaturePlannerWizard /> },
  { path: 'projects/:projectId/features/:featureId/edit', element: <FeaturePlannerWizard /> },
  { path: 'projects/:projectId/features/:featureId', element: <FeatureDetail /> },
  { path: 'departments', element: <Departments /> },
  { path: '/departments/:id/dashboard', element: <DepartmentDashboard /> },
  { path: 'profile', element: <Profile /> },
];

export const adminRoutes = [{ path: 'users', element: <Users /> }];
